import { components } from "@/api-schema";
import { getFullUserName } from "@/common/helpers/get-full-user-name";
import { isUserDeactivated } from "@/common/helpers/user-deactivated";
import { ImplementedDisplayColumnDef } from "@/components/data-table/types";
import { UserAvatar } from "@/components/user-avatar/user-avatar";
import { UserName } from "@/components/user-item/user-name";
import i18next from "i18next";

type UserWithMembershipTableType = components["schemas"]["UserWithMembershipResponseDto"];

export const userWithMembershipTableDefaultColumns = {
  columnAvatar: {
    id: "avatar",
    size: 50,
    enableSorting: false,
    cell: ({ row }) => (
      <UserAvatar
        userAzureObjectUuid={row.original.azureObjectUuid}
        name={getFullUserName({ user: row.original, emailFallback: false, fallback: "" }) || undefined}
        isDeactivated={isUserDeactivated(row.original)}
      />
    ),
  } as ImplementedDisplayColumnDef<UserWithMembershipTableType>,

  columnName: {
    id: "name",
    size: 1000,
    enableSorting: false,
    header: () => i18next.t("common:Name"),
    accessorFn: (row) => getFullUserName({ user: row }),
    cell: (row) => <UserName user={row.row.original} />,
  } as ImplementedDisplayColumnDef<UserWithMembershipTableType>,
};
